import { Component, input } from '@angular/core';

@Component({
  selector: 'wbi-menu-logo',
  standalone: true,
  template: `
    <img src="../../assets/images/wbi-logo-w.svg" class="part w-part" [class.shrink]="shrink()" alt="" />
    <img
      src="../../assets/images/wbi-logo-b.svg"
      class="part b-part"
      [class.out]="shrink()"
      alt=""
    />
    <img
      src="../../assets/images/wbi-logo-i.svg"
      class="part i-part"
      [class.out]="shrink()"
      alt=""
    />
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        gap: 3px;
        height: 100%;
      }

      .part {
        height: 100%;
        width: auto;
        flex-shrink: 0;
        display: block;
      }

      .w-part {
        width: 58px;
      }

      .w-part.shrink {
        align-self: flex-start;
      }

      .b-part,
      .i-part {
        opacity: 1;
        transform: translateX(0);
        transition:
          opacity 200ms ease,
          transform 320ms cubic-bezier(0.34, 1.56, 0.64, 1);
      }

      .b-part {
        transition-delay: 55ms;
      }

      .i-part {
        transition-delay: 115ms;
      }

      .b-part.out,
      .i-part.out {
        opacity: 0;
        transform: translateX(-8px);
        transition-delay: 0ms;
      }
    `,
  ],
})
export class WbiMenuLogoComponent {
  shrink = input<boolean>(false);
}
